import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { translateRoute } from '~/App/shared/localization';
import { useTranslation } from '~/Locale';

export const useBuyNowOpen = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return useMemo(
    () => pathname.includes(translateRoute(t, 'ROUTES.BUY_NOW')),
    [t, pathname]
  );
};
